<template>
  <div class="callers-collapse">
    <div class="row w-100 text-left">
      <icon
        :type="!is_collapse ? 'ios-eye-off' : 'ios-eye'"
        class="callers-collapse__controls-icon col-12 text-left mb-1"
        @click="is_collapse = !is_collapse"
      />
      <p class="col-12 text-left pl-0">
        <tooltip
          v-if="is_collapse"
          :content="$t('shared.component.v-copy.copy')"
          placement="right"
          trigger="hover"
        >
          <span class="flex copy-row" @click="copy">
            {{ password }}
            <icon type="md-copy" size="20" />
          </span>
        </tooltip>

        <span v-else class="callers-collapse__value col">***</span>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      password: {
        type: String,
        default: ''
      },
      is_collapse: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      copy: function () {
        this.$copyText(this.password).then(() => {
          this.$noty.success(this.$t('shared.component.noty.text_copied'));
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .callers-collapse {
    display: flex;
    width: 100%;

    &__main {
      flex: auto;
    }

    &__controls {
      margin-left: 15px;
      align-self: center;
    }

    &__controls-icon {
      font-size: 18px;

      &:hover {
        cursor: pointer;
      }
    }

    &__content {
      .callers-collapse__item {
        margin-top: 10px;
      }
    }

    &__item {
      display: flex;
      flex-direction: column;
    }

    &__name {
      color: #a0a0a0;
    }
  }
</style>
